import { Outlet } from "react-router-dom";
import { Header } from "./header/Header";
import { Nav } from "./nav/Nav";
import { Main } from "./main/Main";
import { Footer } from "./footer/Footer";

export function Layout() {
  return (
    <div className="default-layout dark:bg-neutral-800">
      <Header className="header" />
      <Nav className="nav" />
      <Main className="main">
        <Outlet />
      </Main>
      <Footer className="footer" />
    </div>
  );
}
